import React, { useState } from 'react';
import { useTheme } from '../theme';

export default function LeasingSimulator({ price }) {
  const [advance, setAdvance] = useState(20); 
  const [years, setYears] = useState(5); 
  const [rate, setRate] = useState(7.5); 
  const { tokens, squareTiles } = useTheme();

  const principal = Math.max(price - advance, 0);
  const months = years * 12;
  const monthlyRate = rate / 100 / 12;

  const monthlyPayment =
    principal > 0 && monthlyRate > 0
      ? (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months))
      : principal / months;

  return (
    <div
      style={{
        background: tokens.surface,
        borderRadius: squareTiles ? 0 : 16,
        boxShadow: `0 2px 12px ${tokens.shadowSoft}`,
        padding: 24,
        marginTop: 18,
        color: tokens.text,
        maxWidth: 420,
        border: `1px solid ${tokens.border}`,
      }}
    >
      <h3
        style={{
          fontSize: 22,
          fontWeight: 700,
          margin: 0,
          marginBottom: 16,
          color: tokens.accent,
          textAlign: 'center',
        }}
      >
        Simulator Leasing
      </h3>

      <label style={{ display: 'block', marginBottom: 20 }}>
        Avans (euro): <b>{advance.toLocaleString('ro-RO')} €</b>
        <input
          type="range"
          min={0}
          max={price - 1}
          step={100}
          value={advance}
          onChange={(e) => setAdvance(Number(e.target.value))}
          className="leasing-slider"
        />
      </label>

      <label style={{ display: 'block', marginBottom: 20 }}>
        Perioadă (ani): <b>{years}</b>
        <input
          type="range"
          min={1}
          max={7}
          step={1}
          value={years}
          onChange={(e) => setYears(Number(e.target.value))}
          className="leasing-slider"
        />
      </label>

      <label style={{ display: 'block', marginBottom: 20 }}>
        Dobândă anuală: <b>{rate}%</b>
        <input
          type="range"
          min={1}
          max={20}
          step={0.1}
          value={rate}
          onChange={(e) => setRate(Number(e.target.value))}
          className="leasing-slider"
        />
      </label>

      <div style={{ marginTop: 20, fontSize: 18, fontWeight: 600, textAlign: 'center' }}>
        <span>Rata lunară estimată:</span>
        <div style={{ color: tokens.accent, marginTop: 6, fontSize: 22 }}>
          {monthlyPayment > 0
            ? monthlyPayment.toLocaleString('ro-RO', { maximumFractionDigits: 2 }) + ' €'
            : '—'}
        </div>
      </div>

      <div style={{ marginTop: 10, fontSize: 13, color: tokens.textMuted, textAlign: 'center' }}>
        * Calcul estimativ. Pentru o ofertă exactă, contactează o firmă de leasing auto.
      </div>

      <style jsx>{`
        .leasing-slider {
          width: 100%;
          margin-top: 8px;
          accent-color: ${tokens.accent};
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}
